import { Component } from '@angular/core';

import { BckpPolicySearchResult } from 'src/app/_common/models/search-result';
import { SpecificComponent } from '../specific.component';

@Component({
    selector: 'aa-search-result-bckp-policy',
    templateUrl: './bckp-policy.component.html',
    styleUrls: [
        '../specific-shared.scss',
        '../../../../../../customer/bckp/policies/policies-list/columns-shared.scss',
        './bckp-policy.component.scss'
    ],
    standalone: false
})
export class BckpPolicyComponent extends SpecificComponent<BckpPolicySearchResult>
{
    constructor()
    {
        super();
    }
}
